import styled from "styled-components";

const HeroSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #fff;
    height: 50vh;
    background: url("/images/banner.png");
    padding: 2rem 4rem;

    @media (max-width: 968px) {
        flex-direction: column;
        text-align: center;
        height: auto;
        padding: 2rem;
    }
`;

const HeroText = styled.div`
    color: #6F8ABF;
    flex: 1;
    margin-right: 1rem;

    @media (max-width: 968px) {
        flex: none;
        max-width: 100%;
        margin-right: 0;
    }
`;

function Hero() {
    return (
        <HeroSection>
            <HeroText>
                <img src="/images/logo.png" width="250" alt="Wendaspace logo with fun icon and bold brand name" />
                <h1 style={{ fontWeight: "bolder" }}>Create. <span style={{ color: "#20680a" }}>Personalize.</span> <span style={{ color: "#c93a3a" }}>Export.</span></h1>
                <p style={{ color: "#333" }}>
                    Design and personalize coupons, invoices, invites, landing pages, and more. Ideal for gifts, events, businesses, or everyday moments. Bring your unique vision to life.
                </p>
            </HeroText>
        </HeroSection>
    );
}
export default Hero;